module.exports = AboutCtrl;

// @ngInject
function AboutCtrl($state, localStorageService, Alert, $anchorScroll) {
  try {
    const vm = this;
    vm.moduleName = 'AboutCtrl';
    
    console.log(vm.moduleName, localStorageService.get('state'));

    vm.appName = localStorageService.get('appName');
    vm.appVersion = localStorageService.get('appVersion');
    vm.goHome = function () {
      $state.go('home');
    }
    vm.showLocalCache = function (alert) {
      var cacheContent = {}
      localStorageService.keys().forEach(function(key) {
        cacheContent[key] = localStorageService.get(key)
      })
      Alert.addAlert({ title: 'Local SiteVisit cache', message: JSON.stringify(cacheContent, null, "  "), type: 'errorAlert', alertClass: 'alert-info', appModule: 'pre'});
    }
  } catch(error) {
    Alert.addAlert({ title: 'Error', message: 'Unexpected error: ' + error, type: 'errorAlert', alertClass: 'alert-danger'});
    $anchorScroll();
  }
}